import { render, staticRenderFns } from "./manage-cards.vue?vue&type=template&id=5d8bde42"
import script from "./manage-cards.vue?vue&type=script&lang=js"
export * from "./manage-cards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports